import About from "../components/About"
import MyWork from "../components/MyWork"
import Contact from "../components/Contact"

export const mappingObj = {
    "about-me": <About/>
    , "my-work": <MyWork/>
    , "contact": <Contact/>
}